import { GetRegion, PLAYER_SEGMENT } from 'constants.js';
import Utils from './Utils';
import { getUserId } from './User';
import getFirstNode from './getFirstNode';
class ClaroUrlBuilder {
  static preview(groupResultId) {
    return `${
      document.location.origin
    }/${GetRegion()}${PLAYER_SEGMENT}${groupResultId}?preview=true`;
  }

  static player(groupResultId) {
    return `${
      document.location.origin
    }/${GetRegion()}${PLAYER_SEGMENT}${groupResultId}`;
  }

  static playerRecord(groupId) {
    return `${
      document.location.origin
    }/${GetRegion()}${PLAYER_SEGMENT}${groupId}`;
  }

  static guideChannel(id) {
    return `${document.location.origin}/${GetRegion()}${PLAYER_SEGMENT}${id}`;
  }

  static login() {
    return `${document.location.origin}/${GetRegion()}/login`;
  }

  static register(region) {
    return `/${GetRegion()}/register`;
  }

  static download(region, groupId) {
    return `https://${window.location.hostname}/${region}/download/${groupId}`;
  }

  static home() {
    const firstNode = getFirstNode();

    return `${window.location.origin}/${GetRegion()}/${firstNode}`;
  }

  static myAccount(region) {
    return `${
      document.location.origin
    }/${region}/home/user?micuentafull#micuentacontrolparental`;
  }

  static card(region, groupId) {
    return `${
      window.location.origin
    }/${region}/vcard/renta/payment/${groupId}`;
    // return `https://${window.location.hostname}/${region}/card/renta/payment/${groupId}`;
    // TODO: MODIFICAR CUANDO SE TENGA LA NUEVA CARD
  }

  static mobileGoToApp(region, groupId, isTrailer) {
    return `/${region}/devices?runplayerinapp&group_id=${groupId}${
      isTrailer ? '&isTrailer=true' : ''
    }`;
  }
}

export default ClaroUrlBuilder;
